import gql from 'graphql-tag';

export const OrganizerQuery = gql`
  query OrganizerQuery($organizerId: Int!) {
    organizer(organizerId: $organizerId) {
      id
      title
      slug
      description
      images {
        logo {
          original
          thumbnail
        }
      }
      events {
        cancelled
        id
        bookingEnabled
        occurrenceId
        postponed
        startDate
        title
        races {
          races {
            id
            title
            bookingEnabled
            tickets {
              available
              availabilityType {
                type
              }
              bookingEnabled
            }
          }
        }
      }
    }
  }
`;
